import React from "react";
import PropTypes from "prop-types";
import { Box, CircularProgress } from "@mui/material";
import Table from "reusableComponents/Tables/Table";
import { SUPER_ADMIN } from "../../constants/constants";
import BulkActions from "../../reusableComponents/Tables/Table/BulkActions";
import {ALLOWED_FILE_STATUS_TRANSITIONS} from "../../utlis/constant";

function BatchFilesTableSection({
                                    loading,
                                    files,
                                    rows,
                                    selectedRows,
                                    handleRowsPerPageChange,
                                    handlePageChange,
                                    handleSelectionChange,
                                    handleFileStatusUpdate,
                                    page,
                                    size,
                                    count,
                                    role,
                                }) {

    const handleBulkStatusUpdate = (newStatus) => {
        const fileIds = selectedRows.map(file => file.id);
        handleFileStatusUpdate(fileIds, newStatus);
    };

    const canUpdateFileStatus = () => {
        if (selectedRows.length === 0) return false;

        return selectedRows.every(row => {
            const allowedTransitions = ALLOWED_FILE_STATUS_TRANSITIONS[row.status] || [];
            return allowedTransitions.length > 0;
        });
    };

    const getAvailableStatuses = () => {
        if (selectedRows.length === 0) return [];

        const allTransitions = new Set();
        selectedRows.forEach(row => {
            const transitions = ALLOWED_FILE_STATUS_TRANSITIONS[row.status] || [];
            transitions.forEach(status => allTransitions.add(status));
        });

        return Array.from(allTransitions);
    };

    const footerRow = BulkActions({
        selectedCount: selectedRows.length,
        onClickAction: handleBulkStatusUpdate,
        canUpdate: canUpdateFileStatus(),
        availableStatuses: getAvailableStatuses()
    });

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!files.length) {
        return (
            <Box sx={{ mt: 4, textAlign: "center", color: "#888" }}>
                No files found for this batch.
            </Box>
        );
    }

    return (
        <Box sx={{ pt: 3 }}>
            <Table
                rows={rows}
                collapsed={false}
                collapsedRows={[]}
                selector
                displayFooter={selectedRows.length > 0}
                footerRow={footerRow || {}}
                handleRowsPerPageChange={handleRowsPerPageChange}
                handlePageChange={handlePageChange}
                page={page}
                pageSize={size}
                size={size}
                count={count}
                selectedRows={selectedRows}
                onSelectionChange={handleSelectionChange}
                selectable={role === SUPER_ADMIN}
                hiddenColumns={["id", "StatusTag"]}
            />
        </Box>
    );
}

BatchFilesTableSection.propTypes = {
    loading: PropTypes.bool.isRequired,
    files: PropTypes.array.isRequired,
    rows: PropTypes.array.isRequired,
    selectedRows: PropTypes.array.isRequired,
    handleRowsPerPageChange: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    handleSelectionChange: PropTypes.func.isRequired,
    handleFileStatusUpdate: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    role: PropTypes.string,
};

export default BatchFilesTableSection;
